const initState = {
  loading: false,
  playerIssues: [],
  a4bChats: [],
  a4bSuggestions: [],
  lastDocA4bSuggestions: null,
  hasMoreA4bSuggestions: true,
  isFetchingA4bSuggestions: false,
  errorA4bSuggestions: null,
  userIssues: [],
  refundRequests: [],
  institutes: [],
  messagesById: [],
  hasMorePlayerIssues: true,
  lastDocumentPlayerIssues: null,
  hasMorUserIssues: true,
  lastDocumentUserIssues: null,
  issues: {},
};

const generalReducer = (state = initState, action) => {
  switch (action.type) {
    case "UPDATE_ISSUE":
      return {
        ...state,
        playerIssues: state.playerIssues.map((item) =>
          item.id == action.payload.id
            ? { ...item, status: action.payload.status }
            : item
        ),
        userIssues: state.userIssues.map((item) =>
          item.id == action.payload.id
            ? { ...item, status: action.payload.status }
            : item
        ),
      };
    case "DELETE_ISSUE":
      return {
        ...state,
        playerIssues: state.playerIssues.filter(
          (item) => item.id !== action.payload
        ),
        userIssues: state.userIssues.filter(
          (item) => item.id !== action.payload
        ),
      };
    case "GET_ISSUES_STATS":
      return {
        ...state,
        issues: action.payload,
      };
    case "GET_INSTITUTES":
      return {
        ...state,
        institutes: action.payload,
      };
    case "GET_PLAYER_ISSUES":
      return {
        ...state,
        playerIssues: action.payload.data,
        hasMorePlayerIssues: action.payload.hasMoreDocument,
        lastDocumentPlayerIssues: action.payload.lastDocument,
      };
    case "MORE_GET_PLAYER_ISSUES":
      return {
        ...state,
        playerIssues: [...state.playerIssues, ...action.payload.data],
        hasMorePlayerIssues: action.payload.hasMoreDocument,
        lastDocumentPlayerIssues: action.payload.lastDocument,
      };
    case "GET_USER_ISSUES":
      return {
        ...state,
        userIssues: action.payload.data,
        hasMorUserIssues: action.payload.hasMoreDocument,
        lastDocumentUserIssues: action.payload.lastDocument,
      };
    case "MORE_GET_USER_ISSUES":
      return {
        ...state,
        userIssues: [...state.userIssues, ...action.payload.data],
        hasMorUserIssues: action.payload.hasMoreDocument,
        lastDocumentUserIssues: action.payload.lastDocument,
      };
    case "FETCH_A4B_SUGGESTIONS_PENDING":
      return {
        ...state,
        isFetchingA4bSuggestions: true,
        errorA4bSuggestions: null,
      };
    case "FETCH_A4B_SUGGESTIONS_SUCCESS":
      return {
        ...state,
        a4bSuggestions: action.payload.a4bSuggestions,
        lastDocA4bSuggestions: action.payload.lastDocA4bSuggestions,
        hasMoreA4bSuggestions: action.payload.hasMoreA4bSuggestions,
        isFetchingA4bSuggestions: false,
      };
    case "FETCH_A4B_SUGGESTIONS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        a4bSuggestions: [
          ...state.a4bSuggestions,
          ...action.payload.a4bSuggestions,
        ],
        lastDocA4bSuggestions: action.payload.lastDocA4bSuggestions,
        hasMoreA4bSuggestions: action.payload.hasMoreA4bSuggestions,
        isFetchingA4bSuggestions: false,
      };
    case "FETCH_A4B_SUGGESTIONS_REJECTED":
      return {
        ...state,
        isFetchingA4bSuggestions: false,
        errorA4bSuggestions: action.errorA4bSuggestions,
      };
    case "GET_A4B_CHAT_REFUND_REQUESTS":
      return {
        ...state,
        refundRequests: action.payload,
      };
    case "GET_ALL_CHATS":
      return {
        ...state,
        a4bChats: action.payload,
      };
    case "GET_ALL_MESSAGES_BY_ID":
      return {
        ...state,
        messagesById: action.payload,
      };
    case "GENERAL_LOADER":
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default generalReducer;
